import { useState } from 'react';
import type { ChildContainerProps } from '@/types';
import { MenuContext } from './context';

export const MenuProvider = ({ children }: ChildContainerProps) => {
  const [activeMenu, setActiveMenu] = useState('');

  const value = {
    activeMenu,
    setActiveMenu,
  };

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};
